import '@rainbow-me/rainbowkit/styles.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ConnectButton from './components/ConnectButton';
import createConfiguration, { IConfiguration } from './createConfiguration';
import withConfiguration from './withConfiguration';

window.Buffer = window.Buffer || require('buffer').Buffer;

declare global {
  interface Window {
    __fgwConfig: IConfiguration;
    loadConfiguration: (
      contractAddress: string,
      isDev?: boolean
    ) => Promise<void>;
    renderApp: (elementId: string) => void;
    renderConnectButton: (elementId: string) => void;
  }
}

function waitForConfig(callback: () => void) {
  const interval = setInterval(() => {
    if (window.__fgwConfig) {
      clearInterval(interval);
      callback();
    }
  }, 200);
}

// on page load script
async function loadConfiguration() {
  window.__fgwConfig = await createConfiguration();
}

function renderApp(elementId: string) {
  // make sure config exists
  waitForConfig(() => {
    const AppComponent = withConfiguration(window.__fgwConfig, App);

    const root = ReactDOM.createRoot(
      document.getElementById(elementId) as HTMLElement
    );

    root.render(
      <React.StrictMode>
        <AppComponent />
      </React.StrictMode>
    );
  });
}

function renderConnectButton(elementId: string) {
  // make sure config exists
  waitForConfig(() => {
    const ConnectButtonComponent = withConfiguration(
      window.__fgwConfig,
      ConnectButton
    );

    const root = ReactDOM.createRoot(
      document.getElementById(elementId) as HTMLElement
    );

    root.render(
      <React.StrictMode>
        <ConnectButtonComponent />
      </React.StrictMode>
    );
  });
}

// set to window
window.loadConfiguration = loadConfiguration;
window.renderApp = renderApp;
window.renderConnectButton = renderConnectButton;
